import type { RouteConfig } from "@/types/routestypes";
import { lazy } from "react";

const DealsNPipelinesettings = lazy(() => import("@/pages/DealsNPipelineSettings/DealsNPipelineSettings"));
const DealAndPipelineConfiguration = lazy(() => import("@/pages/DealAndPipelineConfiguration/DealAndPipelineConfiguration"));

const DealAndPipelineSettingsRoute: RouteConfig = {
    path: "",
    pageName: "Deals & pipeline",
    permission: ["DealsandPipelineSettings"],
    children: {
        OPPORTUNITY_SETTING: {
            path: "deal-setting",
            element: <DealsNPipelinesettings />,
            pageName: "Deals & pipeline Setting",
            sidebar: { show: true, icon: "" },
        },
        OPPORTUNITY_CONFIGURATION: {
            path: "custom-field-configuration",
            element: <DealAndPipelineConfiguration />,
            pageName: "Custom Field Configuration",
            sidebar: { show: true, icon: "" },
        },
    },
};

export default DealAndPipelineSettingsRoute;